import React from "react";
import Applet from "../../Applet";
import ETLS3ConfigurationTable from "../../../../components/S3/ETLS3ConfigurationTable";

class ETLS3ConfigurationTableApplet extends Applet {

    render() {
        return <ETLS3ConfigurationTable applet={this}
                                       pageSize={this.state.PageSize}
                                       placement={this.state.Placement}
                                       columns={this.state.Columns}
                                       title="S3 Configurations"
                                       enterpriseComponent={this.getEnterpriseComponent()}
                                       sort={this.state.Sort}
                                       menu={this.state.Menu}
                                       rowHeight={this.state.RowHeight}
        />;
    }

    state = {
        Name: "ETLS3ConfigurationTableApplet",
        Menu: {
            options: [
                {
                    displayValue: "New S3 Configuration",
                    value: "New S3 Configuration",
                },
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                },
            ],
        },
        RowHeight: 60,
        PageSize: {
            "default": 40,
            "xs": 3,
            "sm": 3,
            "md": 40,
            "lg": 40,
            "lx": 40,
        },
        Placement: {
            "xl": [
                {
                    id: "RecordPointer",
                },
                {
                    id: "Name",
                },
                {
                    id: "AWSAccessKeyID",
                },
                {
                    id: "Bucket",
                },
                {
                    id: "Path",
                },
                {
                    id: "Actions",
                },
            ]
        },
        Columns: [
            {
                id: "RecordPointer",
                width: 25,
                cellRenderer: "Row Selection Indicator Cell",
                header: null,
                headerRenderer: "",
                headerTitle: "",
            },
            {
                id: "Name",
                width: 200,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Name",
            },
            {
                id: "AWSAccessKeyID",
                width: 200,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "AWS Access Key ID",
            },
            {
                id: "Bucket",
                width: 300,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Bucket",
            },
            {
                id: "Path",
                width: 300,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Path",
            },
            {
                id: "Actions",
                width: 50,
                cellRenderer: "Action Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "",
                pinned: "right",
                hideable: false,
            }
        ],
        Sort: [
            {
                "Identifier": 1,
                "Visible": true,
                "Default": true,
                "Options": [{
                    "Direction": "DESC",
                    "SortAttribute": "Name",
                    "DisplayName": "Name",
                }]
            }
        ],
    };
}

export default ETLS3ConfigurationTableApplet;
